import { render, staticRenderFns } from "./SnackbarOverlay.vue?vue&type=template&id=2f168adc&scoped=true"
import script from "./SnackbarOverlay.vue?vue&type=script&lang=js"
export * from "./SnackbarOverlay.vue?vue&type=script&lang=js"
import style0 from "./SnackbarOverlay.vue?vue&type=style&index=0&id=2f168adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f168adc",
  null
  
)

export default component.exports